import { CFooter } from '@coreui/react'
import React from 'react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a
          href="https://aiopartners.com"
          className="text-decoration-none"
          target="_blank"
          rel="noopener noreferrer"
        >
          iVetted Private Attestations
        </a>
        <span className="ms-1">&copy; 2023 Vetted IT Ltd.</span>
      </div>
      <div className="ms-auto">
        {/* <span className="me-1">Powered by</span>
        <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          CoreUI React Admin &amp; Dashboard Template
        </a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
